import { LogOut, Search } from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";

import { authStorage } from "../../lib/auth";

import styles from "./TopNav.module.css";

interface NavItem {
  to: string;
  label: string;
  adminOnly?: boolean;
}

const NAV: NavItem[] = [
  { to: "/casos", label: "Gestão de Casos" },
  { to: "/consultar", label: "Consultar Casos" },
  { to: "/enviar", label: "Enviar Casos" },
  { to: "/utilizadores", label: "Página Admin", adminOnly: true },
];

export function TopNav() {
  const navigate = useNavigate();
  const user = authStorage.getUser();
  const isAdmin = user?.is_staff || user?.is_superuser;
  const visibleNav = NAV.filter((item) => !item.adminOnly || isAdmin);
  const initials = (user?.username ?? "?").slice(0, 2).toUpperCase();
  const displayName =
    [user?.first_name, user?.last_name].filter(Boolean).join(" ").trim() ||
    user?.username ||
    "utilizador";

  function handleLogout() {
    authStorage.clear();
    navigate("/login", { replace: true });
  }

  return (
    <nav className={styles.bar}>
      <div className={styles.greeting}>
        <span className={styles.greetingHello}>Olá,</span>
        <span className={styles.greetingName}>{displayName}</span>
      </div>

      <ul className={styles.tabs}>
        {visibleNav.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                [styles.tab, isActive ? styles.active : ""].join(" ")
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>

      <div className={styles.actions}>
        <button className={styles.iconBtn} aria-label="Pesquisar">
          <Search size={20} />
        </button>
        {/* bell / notifications — not yet implemented */}
        <button
          className={styles.avatar}
          aria-label={`Sessão de ${user?.username ?? "utilizador"} — terminar sessão`}
          onClick={handleLogout}
          title="Terminar sessão"
        >
          <span aria-hidden="true">{initials}</span>
          <LogOut size={12} className={styles.avatarLogout} />
        </button>
      </div>
    </nav>
  );
}
